export default __webpack_public_path__ + "static/media/te.ca5507f1.jpg";